import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ChangeDatasourceIconForm from './form'

const ChangeDatasourceIconDialog = React.forwardRef(function ChangeDatasourceIconDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Change Datasource Icon'
      open={dialogState.open}
      onClose={close}
      size='large'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ChangeDatasourceIconForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ChangeDatasourceIconDialog.propTypes = {
  onComplete: PropTypes.func
}

ChangeDatasourceIconDialog.defaultProps = {
  onComplete: () => {}
}

export default ChangeDatasourceIconDialog
